import { render, staticRenderFns } from "./qyStaff.vue?vue&type=template&id=2f96d7e2&scoped=true"
import script from "./qyStaff.vue?vue&type=script&lang=js"
export * from "./qyStaff.vue?vue&type=script&lang=js"
import style0 from "./qyStaff.vue?vue&type=style&index=0&id=2f96d7e2&prod&lang=scss"
import style1 from "./qyStaff.vue?vue&type=style&index=1&id=2f96d7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96d7e2",
  null
  
)

export default component.exports